import {ReactComponent as WorkshopsIcon} from '../assests/categories/workshop-icon.svg';
import {ReactComponent as GeneralIcon} from '../assests/categories/general-icon.svg';
import {ReactComponent as HearDesignIcon} from "../assests/categories/hair-design-icon.svg";
import {ReactComponent as FoodIcon} from "../assests/categories/food-icon.svg";
import {ReactComponent as StudyIcon} from "../assests/categories/study-icon.svg";
import {ReactComponent as ArchitectureIcon} from "../assests/categories/architecture-icon.svg";
import {ReactComponent as GraphicDesignIcon} from "../assests/categories/graphic-design-icon.svg";
import {ReactComponent as SportIcon} from "../assests/categories/sport-icon.svg";
import {ReactComponent as MedicineIcon} from "../assests/categories/medicine-icon.svg";
import {ReactComponent as CameraIcon} from "../assests/categories/camera-icon.svg";
import {ReactComponent as FinanceIcon} from "../assests/categories/israel-shekel-icon.svg";
import {ReactComponent as ElectronicsIcon} from "../assests/categories/electronics-icon.svg";
import {ReactComponent as AdviceIcon} from "../assests/categories/advice-icon.svg";
import {ReactComponent as GardeningIcon} from "../assests/categories/gardening-icon.svg";
import {ReactComponent as FashionIcon} from "../assests/categories/fashion-icon.svg";
import {ReactComponent as PregnancyIcon} from "../assests/categories/pregnancy-icon.svg";
import {ReactComponent as JudaismIcon} from "../assests/categories/judaism-icon.svg";
import {ReactComponent as HealthCareIcon} from "../assests/categories/health-care-icon.svg";
import {ReactComponent as PetsIcon} from "../assests/categories/pets-icon.svg";
import {ReactComponent as BicycleIcon} from "../assests/categories/bicycle-icon.svg";
import {ReactComponent as GroceryIcon} from "../assests/categories/grocery-icon.svg";
import {ReactComponent as PeopleIcon} from "../assests/categories/people-icon.svg";
import {ReactComponent as DrillIcon} from "../assests/categories/drill-idon.svg";
import {ReactComponent as CourtIcon} from "../assests/categories/court-icon.svg";
import {ReactComponent as TravelIcon} from "../assests/categories/travel-icon.svg";
import {ReactComponent as PartyIcon} from "../assests/categories/party-icon.svg";
import {ReactComponent as HealingIcon} from "../assests/categories/healing-hand-icon.svg";

const iconToCategoryMap = {
    'עיצוב שיער' : ()=> <HearDesignIcon className={'button-category-icon'} />,
    'אוכל' : ()=> <FoodIcon className={'button-category-icon'}/>,
    'חינוך' : ()=> <StudyIcon className={'button-category-icon'}/>,
    'אדריכלות ועיצוב' : ()=> <ArchitectureIcon className={'button-category-icon'}/>,
    'עיצוב גרפי, מיתוג ומתנות' : ()=> <GraphicDesignIcon className={'button-category-icon'}/>,
    'ספורט וחוגים' : ()=> <SportIcon className={'button-category-icon'}/>,
    'רפואה' : ()=> <MedicineIcon className={'button-category-icon'}/>,
    'צילום' : ()=> <CameraIcon className={'button-category-icon'}/>,
    'פיננסים' : ()=> <FinanceIcon className={'button-category-icon'}/>,
    'טכנאים ואלקטרוניקה' : ()=> <ElectronicsIcon className={'button-category-icon'}/>,
    'ייעוץ עסקי וליווי אישי' : ()=> <AdviceIcon className={'button-category-icon'}/>,
    'גינון' : ()=> <GardeningIcon className={'button-category-icon'}/>,
    'אופנה וטיפוח' : ()=> <FashionIcon className={'button-category-icon'}/>,
    'הריון ולידה' : ()=> <PregnancyIcon className={'button-category-icon'}/>,
    'יהדות ותשמישי קדושה' : ()=> <JudaismIcon className={'button-category-icon'}/>,
    'רפואה אלטרנטיבית' : ()=> <HealthCareIcon className={'button-category-icon'}/>,
    'חיות מחמד' : ()=> <PetsIcon className={'button-category-icon'}/>,
    'אופניים' : ()=> <BicycleIcon className={'button-category-icon'}/>,
    'מכולת' : ()=> <GroceryIcon className={'button-category-icon'}/>,
    'סדנאות והפעלות' : ()=> <WorkshopsIcon className={'button-category-icon'}/>,
    'שיפוצים ובניה' : ()=> <DrillIcon className={'button-category-icon'}/>,
    'משפטים' : ()=> <CourtIcon className={'button-category-icon'}/>,
    'תיירות' : ()=> <TravelIcon className={'button-category-icon'}/>,
    'אירועים' : ()=> <PartyIcon className={'button-category-icon'}/>,
    'טיפול ורפואה' : ()=> <HealingIcon className={'button-category-icon'}/>,
    'הכל' : ()=> <PeopleIcon className={'button-category-icon'}/>,
    default: ()=> <GeneralIcon className={'button-category-icon'}/>
}

const getIcon = (category)=>{
    if(!category) return iconToCategoryMap.default();
    if(!iconToCategoryMap[category]) return iconToCategoryMap.default();
    return iconToCategoryMap[category]();
}

export default getIcon;